export const shouldRefetchVideoForMismatch = ({
  selectedCameraPk,
  videoCameraPk,
  selectedRowKey,
  videoRowKey,
  hasVideoUrl,
  isLoading,
}: {
  selectedCameraPk: number | null | undefined;
  videoCameraPk: number | null | undefined;
  selectedRowKey: string | null | undefined;
  videoRowKey: string | null | undefined;
  hasVideoUrl: boolean;
  isLoading: boolean;
}): boolean => {
  if (!hasVideoUrl || isLoading) {
    return false;
  }

  // Row-key mismatch is the strongest signal that the visible clip
  // belongs to a different alert than the currently selected one.
  if (selectedRowKey && videoRowKey) {
    return selectedRowKey !== videoRowKey;
  }

  // Fallback for older states where row keys are unavailable.
  if (!selectedCameraPk || !videoCameraPk) {
    return false;
  }

  return selectedCameraPk !== videoCameraPk;
};
